import axios from 'axios';

// 根据环境设置不同的baseURL
const getBaseURL = () => {
  // 如果环境变量中有设置，优先使用环境变量
  if (process.env.REACT_APP_API_BASE_URL !== undefined) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // 在开发环境中使用本地服务器
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3011';
  }

  // 生产环境默认走同源，由 Nginx 把 /api 反代到后端
  return '';
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 添加请求拦截器
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api; 